var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronBackSm18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chevron-back-sm-18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 288 0 288 864 0 864"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18-&-24-Pixel-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Content",
    transform: "translate(-240.000000, -416.000000)",
    stroke: "#F5F5F5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 121.5,
    y: 45.5,
    width: 311,
    height: 1012
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    transform: "translate(-96.000000, -240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 18
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Duplicate-control"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "grid-18",
    mask: "url(#mask-2)",
    x: 96,
    y: 240,
    width: 18,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-96.000000, -240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-back-sm-18",
    transform: "translate(96.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "grid-18",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7052617,14.7060005 C13.0987465,14.3160005 13.0967441,13.6830005 12.7072642,13.2920005 L8.41597679,8.99900048 L12.7072642,4.70600048 C13.0977453,4.31500048 13.0977453,3.68300048 12.706263,3.29200048 C12.3137794,2.90200048 11.6809997,2.90300048 11.2895174,3.29300048 L6.29236022,8.29200048 C6.09711966,8.48800048 6,8.74300048 6,8.99900048 C6,9.25500048 6.09711966,9.51000048 6.29236022,9.70600048 L11.2895174,14.7050005 C11.6809997,15.0960005 12.3137794,15.0960005 12.7052617,14.7060005 Z",
    id: "icon",
    fill: "#6A7070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Slice",
    transform: "translate(-96.000000, -240.000000)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackSm18);
export default __webpack_public_path__ + "static/media/chevron-back-sm-18.18786d79c49ec400ed8d2562f0fba079.svg";
export { ForwardRef as ReactComponent };